(() => {
  const AFFILIATE_RETURN_TO_KEY = 'mxAffiliateReturnTo';
  const redirectTarget = document.querySelector('[data-redirect-url]');

  if (!redirectTarget) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const rawReturnTo = params.get('return_to');
  const storedReturnTo = window.sessionStorage.getItem(AFFILIATE_RETURN_TO_KEY);
  // Only allow same-origin relative paths to prevent open redirect
  const returnTo =
    rawReturnTo && /^\/(?!\/)/.test(rawReturnTo)
      ? rawReturnTo
      : storedReturnTo && /^\/(?!\/)/.test(storedReturnTo)
        ? storedReturnTo
        : null;

  const baseUrl = returnTo || redirectTarget.getAttribute('data-redirect-url');

  if (!baseUrl) {
    return;
  }

  // Extract affiliate code from path: /s/{code}
  const affiliateMatch = window.location.pathname.match(/^\/s\/([^/]+)/);
  const affiliateCode = affiliateMatch
    ? decodeURIComponent(affiliateMatch[1])
    : null;

  let redirectUrl = baseUrl;

  if (affiliateCode) {
    const dest = new URL(baseUrl, window.location.origin);
    dest.searchParams.set('utm_medium', 'affiliate');
    dest.searchParams.set('utm_campaign', affiliateCode);
    redirectUrl = dest.pathname + dest.search;
  }

  if (returnTo) {
    window.sessionStorage.removeItem(AFFILIATE_RETURN_TO_KEY);
  }

  document.documentElement.style.visibility = 'hidden';
  window.location.replace(redirectUrl);
})();
